import React, { useEffect, createElement } from 'react';
// Declare fbq as global function
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
const MetaPixel: React.FC = () => {
  useEffect(() => {
    // Load Facebook Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    `;
    document.head.appendChild(script);
    // Initialize Meta Pixel with your Pixel ID
    window.fbq('init', '1176811334355871');
    // Track PageView event on component mount
    window.fbq('track', 'PageView');
  }, []);
  return null; // This component doesn't render anything
};
export default MetaPixel;